import { getInstallationSourceTokenLink } from './apis';
import { getErrorPropsByServerlessErrorCode, INSTALLER_ERRORS } from '../errors';
export const getInstallationSourceToken = async _ref => {
  let {
    httpClient,
    handleError
  } = _ref;
  try {
    const response = await httpClient.get(getInstallationSourceTokenLink());
    return response.data;
  } catch (error) {
    const errorProps = getErrorPropsByServerlessErrorCode(error, INSTALLER_ERRORS.GENERIC_NO_RETRY);
    await handleError(errorProps);
    return;
  }
};
//# sourceMappingURL=get-installation-source-token.js.map